import { getRoles, insertRole, updateRole, deleteRole } from './actions';
import { rolesSlice } from './roles';

export const { setRoles } = rolesSlice.actions;

export { getRoles, insertRole, updateRole, deleteRole };

export default rolesSlice.reducer;
